export default {
    HIPAA_TRAINING: "HIPAA",
    SECURITY_TRAINING: "SECURITY",
    PCI_TRAINING: "PCI"
}


// WEBPACK FOOTER //
// ./src/utils/subModuleMapping.js